var map = {
	"./data_boms6.0.js": 181,
	"./data_ocrm.js": 182
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;


//////////////////
// WEBPACK FOOTER
// ./core-build-local/lib/testData ^\.\/data_.*\.js$
// module id = 148
// module chunks = 130 131 132 133 134 135